import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** Desktop from 1025px; ≤1024px uses compact / mobile chrome. */
export const DESKTOP_MQ = '(min-width: 1025px)';

export function useIsDesktop() {
  return useMediaQuery(DESKTOP_MQ);
}
